import { trpc } from '@/utils/trpc' // Adjust the path based on your project structure

export function useTeamByInvitation(token?: string) {
  const {
    data: teamData,
    isLoading,
    isRefetching,
    refetch,
    isError: isQueryError,
  } = trpc.getTeamByInvitation.useQuery(
    { token: token || '' },
    {
      enabled: !!token,
      retry: false,
    },
  )

  const {
    data: userTeams,
    refetch: refetchUserTeams,
    isRefetching: isRefetchingUserTeams,
  } = trpc.getUserTeams.useQuery(
    {},
    {
      refetchOnWindowFocus: false,
      enabled: false,
      staleTime: 1000 * 60 * 2, // Cache data for 2 minutes
    },
  )

  return {
    teamData,
    isLoading,
    isRefetching,
    refetch,
    isQueryError,
    userTeams,
    refetchUserTeams,
    isRefetchingUserTeams,
  }
}
